import { Component, OnInit, ViewEncapsulation, NgZone } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { LocalDataSource } from 'ng2-smart-table';
import { Constants } from '../../shared/Constants';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material';
import { NotifierService } from '../shared/notifier/notifier.service';
import { EditarProviderModalComponent } from './modals/editProvider/editProviderModal.component';
import { AlertComponent } from '../shared/alerts/alert.component';
import { ProviderService } from '../services/provider.service';
//import { ClientService } from '../services/client.service';
@Component({
  selector: 'app-provider',
  templateUrl: './provider.component.html',
  styleUrls: ['./styles/provider.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ProviderService]
})
export class ProviderComponent implements OnInit {
  // rows per page
  perPage = 10;
  settings = {
    pager: {
      display: true, perPage: this.perPage
    },
    noDataMessage: 'No hay datos que mostrar.', columns: undefined,
    actions: {
      add: false, delete: false, position: 'right', edit: false, columnTitle: 'Acciones',
      custom: [
        { name: 'editar', title: `<div class="editCustomButton">Editar</div>` },
        { name: 'eliminar', title: `<div class="editCustomButton">Eliminar</div>` }
      ]
    }
  };
  // Filters for the smart table
  filtersForm: FormGroup;
  dataSource = undefined;
  tableSettings = undefined;
  tableData = {} as any;
  //activeWorkers = 0;


  constructor(private fb: FormBuilder,
    private route: ActivatedRoute,
    private providerService: ProviderService,
    public dialog: MatDialog,
    private notifierService: NotifierService, private zone: NgZone) {
    /*this.route.params.subscribe((params) => {
      if (params['JWT']) {
        localStorage.setItem('jwt', params['JWT']);
      }
    });*/
    this.getTableData();
    this.handleNotifier();
    // Se crean los filtros para la tabla
    this.filtersForm = this.fb.group({
      search: '', // busqueda por nombre
    });
    this.filtersForm.valueChanges.subscribe(form => { this.formFilter(form); });
  }

  ngOnInit() {
  }

  getTableData() {
    this.dataSource = new LocalDataSource([]);
    this.providerService.listProviders()
      .subscribe(
        response => {
          this.tableData = {
            columns: {
              comercial_name: { title: 'Nombre Comercial' },
              ruc: { title: 'Numero de Documento' },
              contact_person: { title: 'Persona de Contacto' },
              email: { title: 'Correo' }
            },
            data: {}
          };
          this.tableData.data = response;

          // Se crea el dataSource y se setea las configs
          this.dataSource = new LocalDataSource(this.tableData.data);
          this.tableSettings = this.copyObject(this.settings);
          // Se valida si se pudo obtener la lista
          // tslint:disable-next-line:triple-equals
          if (this.tableData.columns != undefined) {
            this.tableSettings.columns = this.copyObject(this.tableData.columns);
            // Se deshabilita los filtros predefinidos para evitar conflictos
            Object.keys(this.tableSettings.columns).forEach(key => {
              this.tableSettings.columns[key].filter = true;
            });
          }
          // Muestra la imagen en la celda (en vez de mostrar el ID del attachment)
          /*    this.tableSettings.columns.imagen.valuePrepareFunction = this.prepareProfilePicCell; */
          /* this.tableSettings.columns.imagen.type = 'html'; */
        },
        error => {
          console.log('error', error);
        }
      );
  }

  copyObject(obj): object {
    return JSON.parse(JSON.stringify(obj));
  }

  /*prepareProfilePicCell(cell, row): string {
    return (`<img class="profile-pic" alt="ID" src="${Constants.URL_BACKEND}/serv/file/${cell}" />`);
  }*/

  formFilter(form): void {
    const search = form.search;
    const results = [];
    this.tableData.data.forEach(row => {
      if (this.rowContains(row, search)) {
        results.push(row);
      }
    });
    this.dataSource.load(results);
  }

  // Check if a row contains a string in any of its cells
  rowContains(row, needle): boolean {
    return (
      (this.stringContains(row.apellidos, needle))
    );
  }

  // Check if a string contains another
  stringContains(haystack, needle): boolean {
    return (haystack.toLowerCase().indexOf(needle.toLowerCase()) > -1);
  }

  customAction(event) {

    switch (event.action) {
      case 'editar':
        this.notifierService.behaviorNotify({
          action: 'edit',
          model: 'provider',
          object: event.data
        });

        const dialogRef = this.dialog.open(EditarProviderModalComponent);
        dialogRef.afterClosed().subscribe(() => {
          this.zone.run(() => {
            this.getTableData();
          });
        });
        break;
      case 'eliminar':
        const deleteDialog = this.dialog.open(AlertComponent, {
          data: {
            icon: 'exclamation-circle',
            iconColor: 'failure',
            title: 'Aviso',
            text: '¿Está seguro que desea eliminar el Proveedor?',
            options: true
          }
        });
        deleteDialog.afterClosed().subscribe((result) => {
          if (result) {
            this.providerService.deleteProvider(event.data.id).subscribe((deleteResult) => {
              this.notifierService.systemNotify({
                title: 'Éxito',
                message: 'Se ha eliminado el Proveedor con exito',
                type: 'success'
              });
              this.zone.run(() => {
                this.getTableData();
              });
            });
          }

        }, (error) => {
          console.log('error', error);
          this.notifierService.systemNotify({
            title: 'Error',
            message: 'Ha ocurrido un error, por favor contactese con su adminstrador',
            type: 'error'
          });
          this.zone.run(() => {
            this.getTableData();
          });
        });
        break;
    }
  }

  handleNotifier() {
    this.notifierService.notifierObject$.subscribe(
      message => {
        this.getTableData();
        this.showMessage(message.type, message.message);
      }
    );
  }

  showMessage(type, message) {
    switch (type) {
      case 'success':
        this.notifierService.systemNotify({
          title: 'Éxito',
          message: message,
          type: 'success'
        });
        break;
      case 'error':
        this.notifierService.systemNotify({
          title: 'Error',
          message: message,
          type: 'error'
        });
        break;
    }
  }

  openRegister() {
    this.notifierService.behaviorNotify({
      action: 'register',
      model: 'provider',
      object: {}
    });
    const dialogNew = this.dialog.open(EditarProviderModalComponent);
    dialogNew.afterClosed().subscribe(() => {
      this.zone.run(() => {
        this.getTableData();
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/system/provider/provider.component.ts